import React from 'react';
import { Image, useResponsive } from '@common-fe/common-fe';

import settingsBackground from '@/assets/placeholders/ill_settings_decoration.svg';
import manageProfileBannerBackground from '@/assets/placeholders/manage-profile-banner.svg';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import EmployeeInformation from './components/EmployeeInformation/EmployeeInformation';
import EmployeePaymentMethods from './components/EmployeePaymentMethods/EmployeePaymentMethods';
import {
  ManageProfileDashboardContent,
  ManageProfileDashboardWrapper,
} from './ManageProfileDashboard.styles';

interface Props {
  isLimitedAccess?: boolean;
  refetchPaymentMethods: () => void;
  hasAllowedPaymentMethods?: boolean;
}

const ManageProfileDashboard: React.FC<Props> = ({
  isLimitedAccess,
  refetchPaymentMethods,
  hasAllowedPaymentMethods,
}) => {
  const { isMobile } = useResponsive();

  return (
    <ManageProfileDashboardWrapper overflow="hidden" $isMobile={isMobile}>
      {isMobile ? (
        <Image
          src={whiteLabelingConfig?.images?.settingsIllustration || settingsBackground}
          style={{
            position: 'absolute',
            maxHeight: '225px',
            bottom: 0,
            right: 0,
            zIndex: 0,
          }}
        />
      ) : (
        <Image
          src={whiteLabelingConfig?.images?.manageProfileBannerBackground || manageProfileBannerBackground}
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            zIndex: 0,
          }}
        />
      )}

      <ManageProfileDashboardContent
        width="100%"
        direction={isMobile ? 'column' : 'row'}
        align={isMobile ? 'start' : 'center'}
        justify="between"
        style={{ zIndex: 1 }}
      >
        <EmployeeInformation isLimitedAccess={isLimitedAccess} />
        {isLimitedAccess ? null : (
          <EmployeePaymentMethods
            refetchPaymentMethods={refetchPaymentMethods}
            hasAllowedPaymentMethods={hasAllowedPaymentMethods}
          />
        )}
      </ManageProfileDashboardContent>
    </ManageProfileDashboardWrapper>
  );
};

export default ManageProfileDashboard;
